const recaptchaFn = () => {
  if (process.env.NODE_ENV === "development") {
    return false;
  }

  const RECAPTCHA_DISABLED = __RECAPTCHA_DISABLED__ || window.__RECAPTCHA_DISABLED__;
  if (RECAPTCHA_DISABLED && RECAPTCHA_DISABLED.indexOf("<RECAPTCHA_DISABLED>") === -1) {
    return !RECAPTCHA_DISABLED;
  }

  return true;
};

export const useRecaptcha = recaptchaFn();
